(function () {
  if (window.PadelGuideV2) {
    window.PadelGuideV2.init(document);
    return;
  }

  const APP = {
    init(root) {
      this.initTilt(root);
      this.initShapeBands(root);
      this.initWeight(root);
      this.initBalance(root);
      this.initSweet(root);
      this.initCompare(root);
    },

    initTilt(root) {
      const cards = root.querySelectorAll('[data-pg2-tilt]:not([data-pg2-bound])');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      cards.forEach((card) => {
        card.dataset.pg2Bound = 'true';
        const reset = () => {
          card.style.setProperty('--pg2-tilt-x', '0deg');
          card.style.setProperty('--pg2-tilt-y', '0deg');
        };

        if (reduced) {
          reset();
          return;
        }

        card.addEventListener('mousemove', (event) => {
          const rect = card.getBoundingClientRect();
          const px = ((event.clientX - rect.left) / rect.width) - 0.5;
          const py = ((event.clientY - rect.top) / rect.height) - 0.5;
          card.style.setProperty('--pg2-tilt-x', `${py * -8}deg`);
          card.style.setProperty('--pg2-tilt-y', `${px * 10}deg`);
        });

        card.addEventListener('mouseleave', reset);
        reset();
      });
    },

    initShapeBands(root) {
      const groups = root.querySelectorAll('[data-pg2-shapes]:not([data-pg2-bound])');
      groups.forEach((group) => {
        group.dataset.pg2Bound = 'true';
        const bands = Array.from(group.querySelectorAll('[data-pg2-shape-band]'));
        if (!bands.length) return;

        const activate = (band) => {
          bands.forEach((item) => {
            const active = item === band;
            item.classList.toggle('is-active', active);
            const media = item.querySelector('[data-pg2-shape-media]');
            if (media && typeof media.play === 'function') {
              if (active) {
                media.play().catch(() => {});
              } else {
                media.pause();
                media.currentTime = 0;
              }
            }
          });
        };

        const observer = 'IntersectionObserver' in window
          ? new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) activate(entry.target);
              });
            }, { threshold: 0.55 })
          : null;

        bands.forEach((band) => {
          band.addEventListener('mouseenter', () => activate(band));
          band.addEventListener('focusin', () => activate(band));
          if (observer) observer.observe(band);
        });

        activate(bands[0]);
      });
    },

    initWeight(root) {
      const groups = root.querySelectorAll('[data-pg2-weight]:not([data-pg2-bound])');
      groups.forEach((group) => {
        group.dataset.pg2Bound = 'true';
        const buttons = Array.from(group.querySelectorAll('[data-pg2-weight-button]'));
        const panels = Array.from(group.querySelectorAll('[data-pg2-weight-panel]'));
        if (!buttons.length || !panels.length) return;

        const activate = (id) => {
          buttons.forEach((button) => {
            const active = button.dataset.pg2WeightButton === id;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          panels.forEach((panel) => {
            const active = panel.dataset.pg2WeightPanel === id;
            panel.hidden = !active;
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => activate(button.dataset.pg2WeightButton));
          button.addEventListener('mouseenter', () => activate(button.dataset.pg2WeightButton));
          button.addEventListener('focusin', () => activate(button.dataset.pg2WeightButton));
        });

        activate(buttons[0].dataset.pg2WeightButton);
      });
    },

    initBalance(root) {
      const groups = root.querySelectorAll('[data-pg2-balance-group]:not([data-pg2-bound])');
      groups.forEach((group) => {
        group.dataset.pg2Bound = 'true';
        const buttons = Array.from(group.querySelectorAll('[data-pg2-balance-button]'));
        const panels = Array.from(group.querySelectorAll('[data-pg2-balance-panel]'));
        if (!buttons.length || !panels.length) return;

        const activate = (id) => {
          buttons.forEach((button) => {
            const active = button.dataset.pg2BalanceButton === id;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          panels.forEach((panel) => {
            panel.hidden = panel.dataset.pg2BalancePanel !== id;
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => activate(button.dataset.pg2BalanceButton));
          button.addEventListener('mouseenter', () => activate(button.dataset.pg2BalanceButton));
          button.addEventListener('focusin', () => activate(button.dataset.pg2BalanceButton));
        });

        activate(buttons[0].dataset.pg2BalanceButton);
      });
    },

    initSweet(root) {
      const groups = root.querySelectorAll('[data-pg2-sweet-group]:not([data-pg2-bound])');
      groups.forEach((group) => {
        group.dataset.pg2Bound = 'true';
        const buttons = Array.from(group.querySelectorAll('[data-pg2-sweet-button]'));
        const title = group.querySelector('[data-pg2-sweet-title]');
        const subtitle = group.querySelector('[data-pg2-sweet-subtitle]');
        const body = group.querySelector('[data-pg2-sweet-content]');
        const line = group.querySelector('[data-pg2-sweet-line]');
        if (!buttons.length || !title || !subtitle || !body || !line) return;

        const activate = (activeButton) => {
          buttons.forEach((button) => {
            const active = button === activeButton;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
          title.textContent = activeButton.dataset.pg2SweetTitle || '';
          subtitle.textContent = activeButton.dataset.pg2SweetSubtitle || '';
          const sourceBody = activeButton.querySelector('[data-pg2-sweet-source-body]');
          body.innerHTML = sourceBody ? sourceBody.innerHTML : '';
          const position = Number(activeButton.dataset.pg2SweetLinePosition || 44);
          line.style.top = `${position}%`;
          line.style.background = activeButton.dataset.pg2SweetLineColor || '#7f4ef3';
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => activate(button));
          button.addEventListener('mouseenter', () => activate(button));
          button.addEventListener('focusin', () => activate(button));
        });

        activate(buttons[0]);
      });
    },

    initCompare(root) {
      const groups = root.querySelectorAll('[data-pg2-compare]:not([data-pg2-bound])');
      groups.forEach((group) => {
        group.dataset.pg2Bound = 'true';
        const buttons = Array.from(group.querySelectorAll('[data-pg2-compare-button]'));
        const seriesWrap = group.querySelector('[data-pg2-radar-series]');
        const legend = group.querySelector('[data-pg2-compare-legend]');
        const max = Number(group.dataset.pg2Max || 10);
        if (!buttons.length || !seriesWrap || !legend) return;

        const radarCenter = [190, 190];
        const radarPoints = [
          [190, 58],
          [304, 124],
          [304, 256],
          [190, 322],
          [76, 256],
          [76, 124]
        ];

        const buildPoints = (values) => {
          return values.map((value, index) => {
            const [x, y] = radarPoints[index];
            const ratio = Math.max(0, Math.min(value / max, 1));
            return [
              radarCenter[0] + ((x - radarCenter[0]) * ratio),
              radarCenter[1] + ((y - radarCenter[1]) * ratio)
            ];
          });
        };

        const hexToRgba = (hex, alpha) => {
          if (!hex || typeof hex !== 'string' || !hex.startsWith('#')) return `rgba(35,77,112,${alpha})`;
          const raw = hex.slice(1);
          const full = raw.length === 3 ? raw.split('').map((ch) => ch + ch).join('') : raw;
          const num = parseInt(full, 16);
          const r = (num >> 16) & 255;
          const g = (num >> 8) & 255;
          const b = num & 255;
          return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };

        const selected = new Set(
          buttons
            .filter((button) => button.dataset.pg2Selected === 'true')
            .map((button) => button.dataset.pg2CompareButton)
        );

        if (!selected.size && buttons.length) {
          buttons.forEach((button) => selected.add(button.dataset.pg2CompareButton));
        }

        const getActiveButtons = () => buttons.filter((button) => selected.has(button.dataset.pg2CompareButton));

        const render = () => {
          const activeButtons = getActiveButtons();

          buttons.forEach((button) => {
            const active = selected.has(button.dataset.pg2CompareButton);
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          legend.innerHTML = activeButtons.map((button) => {
            const color = button.dataset.pg2Color || '#234d70';
            return `<span class="pg2-compare__legend-chip"><span class="pg2-compare__legend-dot" style="background:${color}"></span>${button.dataset.pg2Title || ''}</span>`;
          }).join('');

          seriesWrap.innerHTML = activeButtons.map((button) => {
            const values = (button.dataset.pg2Values || '0|0|0|0|0|0').split('|').map((value) => Number(value));
            const color = button.dataset.pg2Color || '#234d70';
            const points = buildPoints(values);
            const pointString = points.map(([x, y]) => `${x},${y}`).join(' ');
            return `
              <g>
                <polygon class="pg2-compare__shape-fill" fill="${hexToRgba(color, 0.24)}" points="${pointString}"></polygon>
                <polyline class="pg2-compare__shape-line" stroke="${color}" points="${pointString} ${points[0][0]},${points[0][1]}"></polyline>
              </g>
            `;
          }).join('');
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const id = button.dataset.pg2CompareButton;
            if (selected.has(id) && selected.size > 1) {
              selected.delete(id);
            } else {
              selected.add(id);
            }
            render();
          });
        });

        render();
      });
    }
  };

  window.PadelGuideV2 = APP;
  APP.init(document);

  document.addEventListener('shopify:section:load', (event) => {
    APP.init(event.target);
  });
})();
